export default "__VITE_ASSET__11719665__"